/**
 * 无人车-故障告警
 */
import { UI_PAGE_EVENTS } from '@zto/zpage-ui-element'
import dayjs from 'dayjs'

export default {
  body: {
    type: 'crud',
    actions: {
      query: {
        api: '/sys/admin/alarm/page',
        method: 'POST',
        responseTransform: (res: any) => {
          if (res?.list) {
            return {
              data: res.list,
              total: res.total || 0
            }
          }
          return res
        }
      }
    },
    searchOn: [UI_PAGE_EVENTS.ACTIVATED],
    search: {
      labelWidth: 100,
      items: [
        { type: 'input', prop: 'snCode', label: '无人车SN', span: 6 },
        { type: 'input', prop: 'deviceName', label: '无人车名称', span: 6 },
        {
          label: '故障时间',
          type: 'date-range-picker',
          prop: 'alarmTimeStart',
          toProp: 'alarmTimeEnd',
          defaultTo: 'now',
          defaultRange: 30,
          maxRange: 90
        }
      ]
    },
    toolbar: {
      noExport: true,
      items: []
    },
    table: {
      operation: false,
      innerAttrs: {
        operationPosition: 'right',
        noIndex: false,
        // pageSize: 10,
        // pageSizes: [5, 10, 15, 20],
      },
      columns: [
        { label: '站点编号', prop: 'siteCode', minWidth: 140 },
        { label: '站点名称', prop: 'siteName', minWidth: 140 },
        { label: '小区名称', prop: 'communityName', minWidth: 140 },
        { label: '无人车SN', prop: 'snCode', minWidth: 140 },
        { label: '无人车名称', prop: 'deviceName', minWidth: 140 },
        { label: '故障信息', prop: 'alarmMessage', minWidth: 240 },
        {
          label: '故障时间',
          prop: 'alarmTime',
          minWidth: 160,
          formatter: (row: any) => (row?.alarmTime ? dayjs(row.alarmTime).format('YYYY-MM-DD HH:mm:ss') : '--')
        }
      ]
    }
  }
}
